import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#disabled-button" }),
  /*#__PURE__*/_createTextVNode(" Disabled Button ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" The "),
  /*#__PURE__*/_createVNode("code", null, "disabled"),
  /*#__PURE__*/_createTextVNode(" attribute determines if the button is disabled. ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Default")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Primary")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Success")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Info")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Warning")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Danger")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Plain")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Primary")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Success")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Info")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Warning")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Danger")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_row = _resolveComponent("el-row")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { disabled: "" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "info",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "warning",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            plain: "",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            plain: "",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "info",
            plain: "",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "warning",
            plain: "",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "danger",
            plain: "",
            disabled: ""
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code2), 1)
        ]),
        _: 1
      })
    ])
  ]))
}